import {AxiosInstance} from 'axios'
import _Vue from 'vue'
import BanzaiTasksService from '@/services/banzai-tasks.service'

export default {
  install(
    Vue: typeof _Vue,
    {http}: { http: AxiosInstance }) {
    Vue.prototype.$banzaiTasks = new BanzaiTasksService(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiTasks: BanzaiTasksService;
  }
}
